import { useEffect, useState } from "react";

import { Button, Input, Line, ModalBody, ModalHeader, toast } from "@sorcery/ui";

import { useModal } from "~/providers/ModalProvider";
import { api } from "~/utils/trpc";

type Props = {
  folderId: string;
};

export const FolderRenameModal = ({ folderId }: Props) => {
  const { closeModal } = useModal();
  const trpcUtils = api.useUtils();

  const { mutateAsync: updateFolder, error: trpcError } = api.deck.updateFolder.useMutation({
    onSuccess: () => {
      toast("Folder renamed");
      void trpcUtils.deck.getMyFolders.invalidate();
      void trpcUtils.deck.getByUserId.invalidate();
      closeModal();
    },
  });
  const [folderName, setFolderName] = useState("");
  const [nameMissingError, setNameMissingError] = useState(false);
  const [error, setError] = useState("");

  // Track trpc errors for display
  useEffect(() => {
    if (trpcError) {
      if (trpcError.shape?.data.code === "BAD_REQUEST") {
        setError(trpcError.shape?.message ?? "Something went wrong.");
      } else {
        // don't expose server side error messages
        setError("Something went wrong.");
      }
    }
  }, [trpcError]);

  const onSubmit = () => {
    // clear errs
    setError("");
    setNameMissingError(false);

    if (!folderName) return setNameMissingError(true);

    void updateFolder({
      id: folderId,
      name: folderName,
    });
  };

  return (
    <div className="p-6">
      <ModalHeader title="Rename Folder" />

      <ModalBody>
        {/* item */}
        <div className="mb-2 w-full">
          <div className="mb-1">Name</div>
          <div>
            <Input
              onChange={setFolderName}
              error={nameMissingError}
              placeholder="Rename folder..."
            />
          </div>
        </div>

        {/* error */}
        {error && (
          <div className="text-red my-4" role="alert">
            <p>
              <span className="font-bold">Error. </span>
              {error}
              <span>.</span>
            </p>
          </div>
        )}
      </ModalBody>

      {/* footer */}
      <Line />
      <div className="flex flex-row-reverse pt-4 gap-2">
        <Button onClick={onSubmit}>Submit</Button>
        <Button onClick={closeModal} variant="secondary">
          Cancel
        </Button>
      </div>
    </div>
  );
};
